import axios from 'axios'
import { showSnackbar } from '@/services'

const request = (url, method, data) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      let fullUrl = process.env.VUE_APP_MT_API + '/' + url
      if (method === 'GET' && data) {
        const jsonString = JSON.stringify(data)
        const encodedJson = encodeURIComponent(jsonString)
        fullUrl += '?data=' + encodedJson
      }
      const object = {
        baseURL: fullUrl,
        method: method,
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
      if (localStorage.getItem('user_id')) {
        object.headers['x-user-id'] = localStorage.getItem('user_id');
      }

      if (localStorage.getItem('accessToken')) {
        object.headers['authorization'] = 'Bearer ' + localStorage.getItem('accessToken');
      }
      if (data && method !== 'GET') {
        object.data = data
      }
      const response = await axios.request(object)
      resolve(response.data)
    } catch (err) {
      if (err?.response?.status !== 401) {
        let message = '';
        if (err.response) {
          if (err.response.data.message) {
            message = err.response.data.message
          } else {
            message = JSON.stringify(err.response.data)
          }
        } else {
          message = err.message
        }
        showSnackbar({
          text: message,
          mode: 'error'
        })
        return reject(err)
      } else {
        resolve({})
      }
    }
  })
}

export default {
  // Clients
  getClients() {
    return request('clients', 'GET')
  },
  updateClient(_id, data) {
    return request('clients/' + _id, 'PATCH', data)
  },
  agGridClientsSettings(filter) {
    return request('composite/views/agGrid/clients-settings', 'POST', filter)
  },
  agGridTeamChanges(filter) {
    return request('composite/views/agGrid/team-changes', 'POST', filter)
  },
  agGridAccountingDashboard(filter) {
    return request('composite/views/agGrid/accounting-dashboard', 'POST', filter)
  },
  agGridCommission(filter) {
    return request('composite/views/agGrid/commission', 'POST', filter)
  },
  agGridInvoices(filter) {
    return request('composite/views/agGrid/invoices', 'POST', filter)
  },
  // Projects
  getProjects() {
    return request('projects', 'GET')
  },
  getFirstMonthProject(data) {
    return request('projects/first-month-project', 'GET', data)
  },
  updateProject(_id, data) {
    return request('projects/' + _id, 'PATCH', data)
  },
  agGridProjectsSettings(filter) {
    return request('composite/views/agGrid/projects-settings', 'POST', filter)
  },
  agGridProjectsExpenses(filter) {
    return request('composite/views/agGrid/expenses', 'POST', filter)
  },
  agGridClientProjectsExpenses(filter) {
    return request('projects/views/agGrid/client-expenses', 'POST', filter)
  },
  // Staffs
  getStaffs() {
    return request('staffs', 'GET')
  },
  getStaffsByActivityTag() {
    return request('staffs/by-activity-tags', 'GET')
  },
  agGridUsersSettings(filter) {
    return request('composite/views/agGrid/users-settings', 'POST', filter)
  },
  updateStaff(_id, data) {
    return request('staffs/' + _id, 'PATCH', data)
  },
  // Platforms
  getPlatform(_id, data) {
    return request(`platforms/${_id}`, 'GET', data)
  },
  getPlatforms(data) {
    return request('platforms', 'GET', data)
  },
  updatePlatform(_id, data) {
    return request('platforms/' + _id, 'PATCH', data)
  },
  getBusinessMetrics(_id, data) {
    return request('platforms/' + _id + '/business-metrics', 'GET', data)
  },
  // GPT
  getGptTasks() {
    return request('tools/gpt/tasks', 'GET')
  },
  deleteGptTask(_id) {
    return request('tools/gpt/tasks/' + _id, 'DELETE')
  },
  refreshGptTask(_id, data) {
    return request('tools/gpt/tasks/' + _id, 'PATCH', data)
  },
  getGptTaskTokens(data) {
    return request('tools/gpt/tasks/tokens', 'POST', data)
  },
  addGptTask(data) {
    return request('tools/gpt/tasks', 'POST', data)
  },
  // Activity Tags
  getActivityTags() {
    return request('activity-tags', 'GET')
  },
  // Analytics
  agGridProjectsAnalytics(filter) {
    return request('composite/views/agGrid/projects-analytics', 'POST', filter)
  },
  getProjectsAnalyticsFilters(data) {
    return request('analytics/projects-analytics/filters', 'GET', data)
  },
  getCommissionsAnalyticsInvoices(data) {
    return request('analytics/commissions-analytics/invoices', 'GET', data)
  },
  generateAnalytics(data) {
    return request('analytics/generate', 'GET', data)
  },
  // Activities
  agGridActivities(filter) {
    return request('composite/views/agGrid/activities', 'POST', filter)
  },
  getActivity(_id) {
    return request(`activities/${_id}`, 'GET')
  },
  deleteActivity(_id) {
    return request(`activities/${_id}`, 'DELETE')
  },
  getProcessedCount(platform) {
    return request(`activities/processed-count/${platform}`, 'GET')
  },
  getActivitiesPriceEstimate(data) {
    return request(`activities/price-estimate`, 'POST', data)
  },
  exportActivities(data) {
    return request(`activities/export`, 'POST', data)
  },
  getStartEndDates(data) {
    return request(`activities/start-end-dates`, 'GET', data)
  },
  refreshForProcess(data) {
    return request(`activities/refresh-for-process`, 'POST', data)
  },
  getActivitiesFilters(data) {
    return request(`activities/filters`, 'GET', data)
  },
  workflowProcess(data) {
    return request(`activities/workflow-process`, 'POST', data)
  },
  // Configs
  getConfigs(data) {
    return request('configs', 'GET', data)
  },
  createConfig(data) {
    return request('configs', 'POST', data)
  },
  // Anton
  getFolders() {
    return request('projects/get-folders', 'GET')
  },
  getTimeEntries(data) {
    return request('tasks/time-entries', 'POST', data)
  },
  getTeamTimeLog(data) {
    return request('tasks/team-time-log', 'POST', data)
  },
  getTaskStatuses() {
    return request('tasks/task-statuses', 'GET')
  },
  submitTimelog(data) {
    return request('tasks/submit-timelog', 'POST', data)
  },
  sendReport(data) {
    return request('tasks/send-report', 'POST', data)
  },
  getTasksTeamLog(data) {
    return request('tasks/tasks-timelog', 'POST', data)
  },
  login(data) {
    return request('auth/login', 'POST', data)
  },
  getCurrentUser() {
    return request('staffs/me', 'GET')
  },
  logout() {
    return request('auth/logout', 'GET')
  },
  getTasksByProject(params) {
    return request('tasks/tasks-by-project', 'POST', params)
  },
  registerUser(data) {
    return request('auth/register', 'POST', data)
  },
  forgotPassword(data) {
    return request('auth/forgot-password', 'POST', data)
  },
  resetPassword(data) {
    return request('auth/reset-password', 'POST', data)
  },
  // Contacts
  agGridContacts(filter) {
    return request('composite/views/agGrid/contacts', 'POST', filter)
  },
  agGridContactsCharts(filter) {
    return request('composite/views/agGrid/contacts-charts', 'POST', filter)
  },
  getContactActivities(_id) {
    return request(`contacts/${_id}/activities`, 'GET')
  },
  getContactsFilters(data) {
    return request(`contacts/filters`, 'GET', data)
  },
  updateContact(_id, data) {
    return request('contacts/' + _id, 'PATCH', data)
  },
  // Journal
  getJournalRecords(data) {
    return request(`journals`, 'GET', data)
  },
  // Kpis
  agGridKpi(data) {
    return request(`composite/views/agGrid/kpi`, 'POST', data)
  },
  // Applications
  checkApplication(data) {
    return request(`applications/check-application`, 'POST', data)
  },
  applicationsSettings() {
    return request(`applications/settings`, 'GET')
  },
  generateOuth2Link(link, data) {
    return request(link, 'POST', data)
  },
  applicationSyncArchived(data) {
    return request(`applications/sync-archived`, 'POST', data)
  },
  applicationsConfigs() {
    return request(`applications/configs`, 'GET')
  },
  // Lead Center
  agGridLeadCenterOverview(filter) {
    return request('composite/views/agGrid/lead-center-overview', 'POST', filter)
  },
  // Workflows
  getWorkflows() {
    return request('workflows', 'GET')
  },
  getWorkflow(_id) {
    return request('workflows/' + _id, 'GET')
  },
  createOrUpdateWorkflow(data) {
    return request('workflows', 'POST', data)
  },
  deleteWorkflow(_id) {
    return request('workflows/' + _id, 'DELETE')
  },
  getWorkflowsOptions() {
    return request('composite/workflows-options', 'GET')
  }
}
